import { render, staticRenderFns } from "./Incidents.vue?vue&type=template&id=522dd5e4&scoped=true"
import script from "./Incidents.vue?vue&type=script&lang=js"
export * from "./Incidents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522dd5e4",
  null
  
)

export default component.exports